import { FormattedMessage } from 'react-intl';
import { PropsWithChildren, ReactElement } from 'react';
import { useIsMobile } from '@synergy/components-next';

import { CardSlider, CardSliderProps } from '../card-slider';
import { NewsCard, NewsCardProps } from '../../news-card/news-card';
import { NewsPost } from '../../../models/news-post';
import { ROUTES } from '../../../utils/routes';

export interface NewsSliderProps
    extends PropsWithChildren,
        Pick<CardSliderProps<NewsPost>, 'showAllUrl' | 'totalItems' | 'onLoadMore'>,
        Pick<NewsCardProps, 'onClick'> {
    news: NewsPost[];
}

export const NewsSlider = (props: NewsSliderProps): ReactElement | null => {
    const isMobile = useIsMobile();

    return (
        <CardSlider
            items={props.news}
            renderComponent={item => (
                <NewsCard key={item.id} news={item} href={ROUTES.news.detail.replace(':id', item.id.toString())} />
            )}
            title={<FormattedMessage id="app.news.slider.title" />}
            showAllUrl={props.showAllUrl}
            totalItems={props.totalItems}
            onLoadMore={props.onLoadMore}
            itemWidth={isMobile ? 287 : 489}
        />
    );
};
